import Cross from './sources/close.svg'
import Menu from './sources/menu.svg'
import Logo from './sources/logo.svg'
import LogoFooter from './sources/logo-footer.svg'
import LogoHero from './sources/logo-hero.svg'
import sprite from './sources/sprite.svg'
import Plus from './sources/plus.svg'
import Minus from './sources/minus.svg'
import ArrowUp from './sources/arrow-up.svg'
import Ellipse from './sources/ellipse.svg'
import Arrow from './sources/arrow.svg'
import Pin from './sources/pin.svg'


export const Svg = {
  Cross,
  Menu,
  Logo,
  LogoFooter,
  LogoHero,
  sprite,
  Plus,
  Minus,
  ArrowUp,
  Ellipse,
  Arrow,
  Pin
}
